import { render, staticRenderFns } from "./PageSupplierCustomers.vue?vue&type=template&id=3605b20b&"
import script from "./PageSupplierCustomers.vue?vue&type=script&lang=js&"
export * from "./PageSupplierCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports